import { useWrapAsync } from "@paroicms/front-app-log";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { fetchLogs } from "../../../../api-requests/logs";
import {
  type Pagination,
  type PaginationOptions,
  apiRequestWrapper,
} from "../../../../api/shared/http-client";
import { exportToExcel } from "../../../../helpers/export-to-excel";
import type { Log } from "../../../../helpers/format-logs";
import { dayJsFormat } from "../../../shared/global-tools/dayjs.helpers";
import Navbar from "../../parts/Navbar/Navbar";
import OurDataTable, { type ColumnType } from "../../utils/OurDataTable/OurDataTable";
import Spinner from "../../utils/Spinner/Spinner";
import "./index.scss";

export default function JournalsScreen() {
  const limit = 20;
  const wrapAsync = useWrapAsync();
  const [logs, setLogs] = useState<Log[]>();

  const loadData = async (options: PaginationOptions): Promise<Pagination> => {
    const res = await fetchLogs(options);
    setLogs(res.data);
    return {
      perPage: res.pagination?.perPage ?? limit,
      total: res.pagination?.total ?? res.data.length,
    };
  };

  const handleExport = () => {
    if (!logs) return;

    exportToExcel(logs, columns, {
      fileName: `journals-${new Date().toISOString().split("T")[0]}.xlsx`,
      sheetName: "Journals",
    });
  };

  useEffect(
    wrapAsync(async () => {
      await apiRequestWrapper(async () => {
        await loadData({
          limit,
          page: 1,
        });
      });
    }),
    [],
  );

  const columns: ColumnType<Log>[] = [
    {
      field: "createdAt",
      header: "Date & Heure",
      body: (log) => <>{dayJsFormat(log.createdAt)}</>,
    },
    {
      field: "ip",
      header: "IP",
    },
    {
      field: "author.lastname",
      header: "Nom",
    },
    {
      field: "author.firstname",
      header: "Prénom",
    },
    {
      field: "author.email",
      header: "Email",
    },
    {
      field: "description",
      header: "Description",
    },
  ];

  if (!logs) return <Spinner />;
  return (
    <div>
      <Navbar pageTitle="Journals" />

      <div className="JournalsScreen">
        <div className="JournalsScreen-dataTableContainer">
          <div className="JournalsScreen-dataTableHeader">
            <Button className="Btn sm primary" label="Exporter" onClick={handleExport} />
          </div>

          <div className="Card">
            <OurDataTable<Log>
              data={logs}
              columns={columns}
              options={{
                rows: limit,
                stripedRows: true,
                tableStyle: { minWidth: "40rem" },
              }}
              loadData={loadData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
